
<app-navbar></app-navbar>
<app-side-navbar></app-side-navbar>

<div style="min-height: 100vh;" class="bg-alag-blue">
    <router-outlet></router-outlet>
    <app-login-register-modal></app-login-register-modal>
</div>

<div class="d-flex flex-column justify-content-center align-items-center flex-wrap" id="loader" *ngIf="common.loader">
    <!-- <div class="loader">
    </div> -->
    <img src="../assets/images/loader.gif" alt="" width="72">
    <div *ngIf="transactionService.transactionInitiated" class="w-100 text-danger text-center bg-dark py-3 mt-2">
        DO NOT REFRESH THIS PAGE<br />
        GO TO YOUR WALLET APP AND APPROVE THE TRANSACTION
    </div>
</div>

<app-footer></app-footer>